import { Resource as e } from "@coveo/platform-client";
import { AnswerConfigurationResource as n } from "./configuration/AnswerConfiguration.js";
import { AnswerEvaluationResource as t } from "./evaluation/AnswerEvaluationResource.js";
import { AnswerRuleResource as u } from "./rule/AnswerRuleResource.js";
class f extends e {
  constructor(o, r) {
    super(o, r), this.configuration = new n(o, r), this.evaluation = new t(o, r), this.rule = new u(o, r);
  }
}
export {
  f as AnswerResource
};
//# sourceMappingURL=AnswerResource.js.map
